module.exports = __webpack_public_path__ + "img/1486728233.b95961cd.jpg";